<template>
	<v-flex :class="classes">
	 {{ nValue }}
	  
	 <comp-field-date
		 	v-for="(value, index) in nValue" :value="value" :key="index" @input="handleChange(value, index)" />
	 

	</v-flex>
</template>

<script>
import { propsMixin } from '@/mixins/FieldsProps'

export default {
	mixins: [propsMixin],
	data() {
		return {
			nValue: {}
		}
	},
	created() {
		if (this.value) this.nValue = this.value
	},
	methods: {
		handleChange(valor, index) {
			
			this.nValue[index] = valor
			
				this.$emit('input', this.nValue)
		}
	}
}
</script>
